import { createHandlerChainRunner, Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { Category } from "@insite/client-framework/Services/CategoryService";
import {
    GetAlsoPurchasedProductCollectionApiV2Parameter,
    GetProductCollectionApiV2Parameter,
    GetRelatedProductCollectionApiV2Parameter,
} from "@insite/client-framework/Services/ProductServiceV2";
import {
    chain,
    LoadProducts,
} from "@insite/client-framework/Store/Components/ProductCarousel/Handlers/LoadCarouselProducts";
import loadProductInfoList from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { BrandModel } from "@insite/client-framework/Types/ApiModels";
import CustomloadProductInfoList from "@tSurya/Store/Components/ProductInfoList/Handlers/LoadProductInfoListExtention";

interface Parameter {
    carouselId: string;
    carouselType: string;
    relatedProductType: string;
    seedWithManuallyAssigned: string;
    displayProductsFrom: string;
    selectedCategoryIds: string[];
    numberOfProductsToDisplay: number;
    isProductDetailsPage: boolean;
    productId?: string;
    isProductListPage: boolean;
    category?: Category;
    isBrandDetailsPage: boolean;
    brand?: BrandModel;
    isShellEdit?: boolean;
}

interface Props {
    getProductCollectionParameter?:
        | GetProductCollectionApiV2Parameter
        | GetRelatedProductCollectionApiV2Parameter
        | GetAlsoPurchasedProductCollectionApiV2Parameter;
    extraProductCollectionParameter?:
        | GetProductCollectionApiV2Parameter
        | GetRelatedProductCollectionApiV2Parameter
        | GetAlsoPurchasedProductCollectionApiV2Parameter;
}

type HandlerType = Handler<Parameter, Props>;

export const recentlyViewedGetProductCollectionParameter:
    | GetProductCollectionApiV2Parameter
    | GetRelatedProductCollectionApiV2Parameter = {
    filter: "recentlyViewed",
    pageSize: 999,
};

export const LoadProductsProperties: HandlerType = props => {
    if (!props.getProductCollectionParameter) {
        return;
    }

    const extraProductOptions = props.extraProductCollectionParameter
        ? {
              getProductCollectionParameter: props.extraProductCollectionParameter,
              numberOfProductsToDisplay: props.parameter.numberOfProductsToDisplay,
          }
        : undefined;

    const isRecentlyViewedOnPDP =
        props.parameter.carouselType === "recentlyViewed" && props.parameter.isProductDetailsPage;

    props.getProductCollectionParameter.expand
        ? props.getProductCollectionParameter.expand.push("images")
        : (props.getProductCollectionParameter.expand = ["images", "properties"]);

    props.dispatch(
        CustomloadProductInfoList({
            id: props.parameter.carouselId,
            getProductCollectionParameter: props.getProductCollectionParameter,
            extraProductOptions,
            excludeProductId: isRecentlyViewedOnPDP ? props.parameter.productId : undefined,
            forceLoad: isRecentlyViewedOnPDP,
            isShellEdit: props.parameter.isShellEdit,
        }),
    );
};

replaceInChain(chain, LoadProducts, LoadProductsProperties);
